export const tariffFormStyles = (theme) => ({
  fullForm: {
    // '& input:disabled': {
    //   border: 'none',
    //   padding: 0,
    //   color: 'black',
    //   '&:before': {
    //     content: '"HELP!!!"',
    //     backgroundColor: 'red',
    //   },
    //   '&:after': {
    //     content: '"NOT WORKING"',
    //   },
    // },
  },
  upperButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    paddingTop: 24,
    [theme.breakpoints.down('lg')]: {
      paddingTop: 0,
      // justifyContent: 'center',
    },
  },
  bottomButtons: {
    marginTop: 40,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
})
